import { createFileRoute } from '@tanstack/react-router';
import { NewCampaignPage } from '@/features/marketing';

/** New campaign › A spot at an event: the one-screen page create with a required event day. */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/new_/event')({
  component: NewEventCampaignRoute,
});

function NewEventCampaignRoute() {
  const { orgId } = Route.useParams();
  return <NewCampaignPage orgId={orgId} shape="EVENT" />;
}
